// hooks/useCreateNewReservation.ts
import { useDispatch, useSelector } from 'react-redux';
import { baseStore, RootState } from '../store'; // Adjust the import based on your file structure
import Logger from '../helpers/logger';
import ErrorTracker from '../helpers/errorTracker';
import { setGroupsByLocation, groupsLoadFailed, groupsLoadStarted } from '../slice/bookingCreation/bookingCreationSlice';
import { locationsApiSlice } from '../../api/locations/locationsApiSlice';
import { notifyLoadFailure, queryResultError } from '../helpers/failureNotification';
import { categoryFromSearch } from '../../modules/home/homeTiles';


const fetchGroupsCall = async(locationId: string, types?: string, productCategory?: string) => {
    const data = await baseStore.dispatch(
        locationsApiSlice.endpoints.getLocationEquipment.initiate({
            locationId: locationId,
            types,
            ...(productCategory ? { productCategory } : {}),
        })
    )
    return data;
};

export const useFetchGroups = (types?: string) => {
  const selectedLocation = useSelector((state: RootState) => state.bookingCreation.selectedLocation);
  const dispatch = useDispatch();

  const fetchGroups = async () => {
    try {
        if (selectedLocation){
            dispatch(groupsLoadStarted());
            // #3429 step 3: entered from a category tile, only that
            // category's products — read from the URL with the home tiles'
            // own parser, as the room flows do.
            const productCategory = categoryFromSearch(window.location.search);
            const result = await fetchGroupsCall(selectedLocation.id, types, productCategory);
            // `initiate` resolves with `{ error }` instead of throwing: a
            // failed load used to leave the selection step spinning (#1970).
            const failure = queryResultError(result);
            if (failure) {
                Logger.for('fetchGroups').error(failure);
                ErrorTracker.trackException(failure as Error);
                dispatch(groupsLoadFailed(selectedLocation.id));
                notifyLoadFailure(dispatch, 'book_location.error.fetch_equipment');
            }
            // Answered for a category the customer has since left (back, then
            // another tile): not this screen's list any more.
            const stale = categoryFromSearch(window.location.search) !== productCategory;
            if (result.data && !stale) {
                dispatch(setGroupsByLocation({ locationId: selectedLocation.id, groups: result.data }))
            }
        }
    } catch (error) {
      Logger.for('createNewReservation').error(error);
      ErrorTracker.trackException(error as Error);
      if (selectedLocation) {
        dispatch(groupsLoadFailed(selectedLocation.id));
      }
      notifyLoadFailure(dispatch, 'book_location.error.fetch_equipment');
    }
  };

  return fetchGroups;
};
